var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.text
    ? _c(
        "div",
        {
          on: {
            click: function($event) {
              return _vm.$emit("click", $event)
            }
          }
        },
        [
          _vm.text.length <= _vm.length
            ? _c("div", [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])
            : _c(
                "v-tooltip",
                {
                  attrs: { bottom: "", "max-width": "50%" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function({ on }) {
                          return [
                            _c("div", _vm._g({}, on), [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm._f("truncate")(_vm.text, _vm.length)
                                  ) +
                                  "\n      "
                              )
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1026691634
                  )
                },
                [
                  _vm._v(" "),
                  _c("span", [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")])
                ]
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }